export class User{

    constructor(
        public email: string,
        public id: number,
        public service: string,
        public manager?: User,
        ){}
}